import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const productMachineOeeTodo = createAsyncThunk('productMachineOee', async ({ navigate, machine_id, shift_id, from_date, to_date }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `oee_report`,
            params: {
                machine_id: machine_id || undefined,
                shift_id: shift_id || undefined,
                from_date: from_date || undefined,
                to_date: to_date || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const productMachineOeeSlice = createSlice({
    name: 'productMachineOee',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(productMachineOeeTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(productMachineOeeTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default productMachineOeeSlice.reducer;
